import Step1 from './Step1/Step1'
import Step2Bd from './Step2/Step2Bd'
import Step2File from './Step2/Step2File'
import Step3 from './Step3/Step3'

export const Step1Page = Step1;
export const Step2BdPage = Step2Bd;
export const Step2FilePage = Step2File;
export const Step3Page = Step3;